import React from "react"
import moment from "moment"
import sweetalert from "sweetalert"

import Layout from "../components/layout"
import SEO from "../components/seo"

import DATES from "../data/dates"

import Beer from "../images/beer.svg"
import Fun from "../images/fun.svg"
import swal from "sweetalert";

const TOMORROW = moment().add(1, 'day');
const dryDayDetails = DATES.find(occasion => TOMORROW.isSame(occasion.date, 'day'))
const SUBTEXT = dryDayDetails ?
`And unfortunately, it is a dry day on account of ${dryDayDetails.occasion}. You might want to stock up today.`:
`And fortunately, it isn't a dry day. Hope you have a good time!`

let LIST = '';
DATES.forEach(event => LIST += `<li>${event.occasion} on the ${event.date.format('Do of MMMM')}</li>`);

const showDryDayList = () => {
  const wrapper = document.createElement('ul');
  wrapper.innerHTML = LIST;
  swal({
    title: 'Dry Day List - 2019',
    content: wrapper,
  })
}

const IndexPage = () => (
  <Layout>
    <SEO title="Is Tomorrow A Dry Day" keywords={[`dryday`, `dry day`, `India`]} />
    <div className="flex h-full flex-col lg:flex-row">
      <div className="flex-1 px-4 lg:px-10 flex flex-col">
        <header className="flex mt-4 justify-center">
          <img alt="beer mug" src={Beer} className="h-10 w-10 mr-2" />
          <h1 className="text-xl lg:text-2xl flex items-center">Is Tomorrow A Dry Day?</h1>
        </header>
        <main style={{ flex: 2 }} className="flex justify-center items-center flex-col">
          <div className="text-center">
            <h3>Tomorrow is the {TOMORROW.format('Do of MMMM')}</h3>
            <h5>{SUBTEXT}</h5>
          </div>
          {/* <!-- Begin Mailchimp Signup Form --> */}
          <div className="mt-10">
            <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css" />
            <div id="mc_embed_signup">
              <h5 className="mb-0 text-center">To get these updates by email, join our mailing list!</h5>
              <form action="https://herokuapp.us19.list-manage.com/subscribe/post?u=48b4d24a0de41413963c0d06a&amp;id=22f1ffa91d" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                  <div id="mc_embed_signup_scroll">
                    <input type="email" defaultValue="" name="EMAIL" className="email" id="mce-EMAIL" placeholder="Email Address" required />
                    {/* <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--> */}
                    <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_48b4d24a0de41413963c0d06a_22f1ffa91d" tabIndex="-1" defaultValue="" /></div>
                    <div className="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" /></div>
                  </div>
              </form>
            </div>
          </div>

          {/* <!--End mc_embed_signup--> */}
        </main>
        <footer className="flex justify-between flex-1 lg:flex-initial">
          <div>
            Built with
            <span className="text-red-600 mx-1">♥</span>
            by
            <a className="ml-1 text-blue-500 underline mb-4" href="https://farazpatankar.com/"> Faraz Patankar</a>
          </div>
          <div className="underline text-blue-500 cursor-pointer" onClick={() => showDryDayList()}>
            Dry Day List!
          </div>
        </footer>
      </div>
      <div className="flex-1 bg-yellow-300 hidden lg:flex lg:align-center">
        <img alt="people having fun" className="px-8" src={Fun} />
      </div>
    </div>
  </Layout>
)

export default IndexPage
